<section class="offer" tabindex="-1" aria-label="Kreditangebote">
  <div
    class="offer__filter-selected"
    *ngIf="resultPage && chipsData.length !== 0"
  >
    <ng-container *ngFor="let chip of chipsData; trackBy: trackByChip">
      <div class="filter-selected__card" (click)="removeChip(chip)">
        <p>{{ chip.text }} <span>&#10005;</span></p>
      </div>
    </ng-container>
    <button class="filter-selected__clean" (click)="resetFilter()">
      alle zurücksetzen
    </button>
    <div class="offer__overlay" *ngIf="filterOverlay"></div>
  </div>
  <div
    class="offer__rising-interest"
    *ngIf="(offersData?.length >= 1 || showDefaultPlaceholders) && !pageType"
    tabindex="0"
    role="alert"
    aria-labelledby="rising-interest-title"
    aria-describedby="rising-interest-description"
  >
    <svg-icon
      src="/resultpage/assets/icons/Stoppuhr.svg"
      [svgStyle]="{ 'width.px': 25 }"
      aria-hidden="true"
    ></svg-icon>
    <div>
      <h2 id="rising-interest-title">
        Jetzt Kredit sichern, bevor die Zinsen wieder steigen - Angebote nur
        wenige Tage gültig!
      </h2>
      <h3 *ngIf="resultPage" id="rising-interest-description">
        Bereits 1% Zinserhöhung bedeutet für Ihre Anfrage über
        {{
          loanFilterData
            ? (loanFilterData.value * 0.01).toLocaleString("de-DE", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })
            : 0
        }}
        € höhere Gesamtkosten.
      </h3>
    </div>
  </div>

  <div *ngIf="offersData?.length === 0 && !showDefaultPlaceholders">
    <p class="offer__rollingTextTop">
      <span class="amount__icon-exclamationWrap"
        ><span class="amount__icon-exclamation">!</span></span
      >
      Kein Treffer zu Ihrer Suche über
      <span class="amount__loanAmount"
        >{{
          loanFilterDataValue.toLocaleString("de-DE", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
        }}
        € für {{ loanFilterDataDuration }} Monate.
      </span>
      Wir suchen nach Alternativen für Sie... Fügen Sie einen zweiten
      Kreditnehmer hinzu, um Ihre Bonität zu verbessern.
    </p>
  </div>
  <div class="offer__sort">
    <div *ngIf="eternalPage" class="sort__title">
      <h3>
        <ng-container *ngIf="pageType === 'active'">Aktive Kredite</ng-container>
        <ng-container *ngIf="pageType === 'archive'">Abgelaufene Kredite</ng-container>
        <ng-container *ngIf="!pageType">Alle Angebote</ng-container>
      </h3>
      <div class="title__data">
        <p *ngIf="minAmount" class="title__data-amounts">
          <strong
            ><span>{{
              minAmount.toLocaleString("de-DE", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })
            }}</span>
            € -
            <span>{{
              maxAmount.toLocaleString("de-DE", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })
            }}</span>
            €</strong
          >
          Kreditsumme
        </p>
        <div class="title__data-months">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <!--! Font Awesome Free 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. -->
            <path
              d="M152 64H296V24C296 10.75 306.7 0 320 0C333.3 0 344 10.75 344 24V64H384C419.3 64 448 92.65 448 128V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V128C0 92.65 28.65 64 64 64H104V24C104 10.75 114.7 0 128 0C141.3 0 152 10.75 152 24V64zM48 248H128V192H48V248zM48 296V360H128V296H48zM176 296V360H272V296H176zM320 296V360H400V296H320zM400 192H320V248H400V192zM400 408H320V464H384C392.8 464 400 456.8 400 448V408zM272 408H176V464H272V408zM128 408H48V448C48 456.8 55.16 464 64 464H128V408zM272 192H176V248H272V192z"
            />
          </svg>
          <p>
            <strong>{{ minMonth }} - {{ maxMonth }} Monate</strong> Laufzeit
          </p>
        </div>
      </div>
    </div>

    <ng-container *ngIf="anyOffers && !twoApplicants">
      <button class="button" (click)="redirectToApptrack()">
        zweiten Kreditnehmer hinzufügen
      </button>
    </ng-container>
    <ng-container *ngIf="offersData?.length > 0">
      <div class="sort__filter" id="sorting" #sorting>
        <div class="page-overlay" (click)="closeSorting()"></div>
        <button class="filter__dropbtn" (click)="openSorting()">
          Sortieren nach: {{ sortingValue?.name }} <i class="arrow down"></i>
        </button>
        <div class="filter__dropdown-content">
          <ng-container *ngFor="let item of sortingDropdown; trackBy: trackBySortValue">
            <div class="dropdown-content__item" (click)="onChangeSorting(item)">
              {{ item.name }}
            </div>
          </ng-container>
        </div>
        <div class="offer__overlay" *ngIf="filterOverlay"></div>
      </div>
    </ng-container>
    <ng-container *ngIf="offersData?.length > 0">
      <div
        class="offer_tab-sort"
        role="tablist"
        aria-label="Sortieroptionen für Angebote"
      >
        <div
          *ngFor="let item of sortingDropdown; let i = index; trackBy: trackBySortValue"
          class="offer_tab-sort--item"
          [ngClass]="{
            'offer_tab-sort--item__active': sortingValue?.value === item.value
          }"
          role="tab"
          [attr.aria-selected]="sortingValue?.value === item.value"
          [attr.tabindex]="sortingValue?.value === item.value ? 0 : -1"
          (click)="onChangeSortingTabs(item)"
          (keydown)="onTabKeydown($event, item, i)"
        >
          {{ item.name }}
        </div>
      </div>
    </ng-container>
  </div>
  <div *ngIf="false">
    <app-customer-improvement></app-customer-improvement>
  </div>
  <div class="offer__explanation" *ngIf="false && explanation">
    <p *ngIf="sortingValue === 'Relevanz'">
      Die Sortierung nach {{ sortingValue?.name }} basiert auf den Abschlüssen
      und Bewertungen unserer Kunden und der Attraktivität der Preise.
      <a href="#">Mehr erfahren.</a>
      <span (click)="closeExplanation()">&#10005;</span>
    </p>
    <p *ngIf="sortingValue !== 'Relevanz'">
      Die Sortierung nach {{ sortingValue?.name }}.
      <a href="#">Mehr erfahren.</a>
      <span (click)="closeExplanation()">&#10005;</span>
    </p>
  </div>
  <ng-container *ngFor="let card of offersData; let i = index; trackBy: trackByOfferId">
    <app-offer-card
      *ngIf="i === 0"
      [cardData]="card"
      [offersType]="'offersOfApplication'"
      [eternalPage]="eternalPage"
      [resultPage]="resultPage"
      [twoApplicants]="twoApplicants"
      [pageType]="pageType"
    ></app-offer-card>
  </ng-container>
  @if (resultpageService.smilyContext(); as smilyContext) {
    <app-smily-infobox [smilyContext]="smilyContext"></app-smily-infobox>
  }
  <ng-container *ngFor="let card of offersData; let i = index; trackBy: trackByOfferId">
    <app-offer-card
      *ngIf="i === 1"
      [cardData]="card"
      [offersType]="'offersOfApplication'"
      [eternalPage]="eternalPage"
      [resultPage]="resultPage"
      [twoApplicants]="twoApplicants"
      [pageType]="pageType"
    ></app-offer-card>
  </ng-container>
  <app-sales-agent-box
    *ngIf="showSalesBox && offersData && offersData.length > 0"
    [offerId]="offersData[0]?.id"
  ></app-sales-agent-box>
  <ng-container *ngFor="let card of offersData; let i = index; trackBy: trackByOfferId">
    <app-offer-card
      *ngIf="i >= 2"
      [cardData]="card"
      [offersType]="'offersOfApplication'"
      [resultPage]="resultPage"
      [eternalPage]="eternalPage"
      [twoApplicants]="twoApplicants"
      [pageType]="pageType"
    ></app-offer-card>
  </ng-container>
  <app-default-box *ngIf="showDefaultPlaceholders"></app-default-box>
  <ng-container *ngFor="let card of noOffersData; let i = index; trackBy: trackByOfferId">
    <app-offer-card
      [cardData]="card"
      [offersType]="'noOffersOfApplication'"
      [resultPage]="resultPage"
      [twoApplicants]="twoApplicants"
    ></app-offer-card>
  </ng-container>
</section>
